// Milestone 2 Agenda + Meeting — presentation labels/helpers (backend authoritative).

export const MEETING_STATUS = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  scheduled: { label: "Scheduled", cls: "bg-brand-civic-50 text-brand-civic border-brand-civic/30" },
  published: { label: "Published", cls: "bg-brand-teal-50 text-brand-teal border-brand-teal/30" },
  in_progress: { label: "In Progress", cls: "bg-brand-gold-50 text-[#9A7212] border-brand-gold/40" },
  completed: { label: "Completed", cls: "bg-slate-100 text-slate-500 border-slate-300" },
  cancelled: { label: "Cancelled", cls: "bg-red-50 text-red-600 border-red-200" },
};

export const ELIGIBILITY = {
  ELIGIBLE: { label: "Eligible", cls: "bg-brand-teal-50 text-brand-teal border-brand-teal/30" },
  PENDING_APPROVAL: { label: "Pending Approval", cls: "bg-brand-gold-50 text-[#9A7212] border-brand-gold/40" },
  MISSED_DEADLINE: { label: "Missed Deadline", cls: "bg-red-50 text-red-600 border-red-200" },
  ALREADY_SCHEDULED: { label: "Already Scheduled", cls: "bg-slate-100 text-slate-500 border-slate-300" },
  FUTURE_ELIGIBLE: { label: "Future Eligible", cls: "bg-slate-100 text-slate-500 border-slate-300" },
};

export const OUTCOME_LABELS = {
  approved: "Approved", denied: "Denied", continued: "Continued", withdrawn: "Withdrawn",
  tabled: "Tabled", no_action: "No Action", amended: "Amended", discussed: "Discussed",
};

export const MEETING_TYPE_LABELS = {
  regular: "Regular Meeting", special: "Special Meeting",
  workshop: "Workshop", public_hearing: "Public Hearing",
};

export function fmtMeetingDate(d, t) {
  if (!d) return "—";
  try {
    const base = new Date(`${d}T${t || "00:00"}`);
    const day = base.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" });
    return t ? `${day} · ${base.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}` : day;
  } catch { return d; }
}

export function deadlineMessage(dl) {
  if (!dl || !dl.deadline_date) return "";
  const n = dl.days_remaining;
  if (dl.passed) return `Deadline passed ${Math.abs(n)} day${Math.abs(n) === 1 ? "" : "s"} ago`;
  if (n === 0) return "Due today";
  if (n === 1) return "Due tomorrow";
  return `${n} days remaining`;
}
